/**
 * 
 */
export function loadHttpHeaders(){
	var headers = {  	      
	        'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',
	        'Content-Type': 'application/x-www-form-urlencoded'
	      }
	return headers;
}

export function loadAjaxBody(formName, params){
    return formName+'='+formName+'&'+formName+':submitButton=&javax.faces.ViewState=' + Tier0.get("javax.faces.ViewState").value+'&'+params;
}


export function getOtpDevicePosition(keyItem){
	if(keyItem!=""){
		if(keyItem=="mailid")
			return 0;
		else if (keyItem=="phone1")
			return 1;
		else if (keyItem=="phone2")
			return 2;
		else if (keyItem=="phone3")
			return 3;
		else if (keyItem=="phone4")
			return 4;
		else if (keyItem=="Q")
			return "Q";
	}
	return -1;
}


// WEBPACK FOOTER //
// ./src/components/utils/utils.js